import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSliderModule, Options } from '@angular-slider/ngx-slider';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, NgxSliderModule, NgClass],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderComponent),
    },
  ],
  selector: 'aux-slider',
  styleUrls: ['./slider.component.scss'],
  templateUrl: './slider.component.html',
})
export class SliderComponent implements ControlValueAccessor, OnChanges {
  private cdr = inject(ChangeDetectorRef);

  disabled?: boolean;
  fc = new FormControl();
  @Input() maxLabel?: null | string;
  @Input() minLabel?: null | string;
  @Input() options!: Options;
  @Input() type: 'number' | 'percent' = 'number';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.options?.currentValue) {
      this.options = {
        ...changes.options.currentValue,
        disabled: this.fc.disabled,
        hideLimitLabels: true,
        translate: (value: number): string => {
          switch (this.type) {
            case 'percent':
              return `${value}%`;
            default:
              return `${value}`;
          }
        },
      };
    }
  }

  onChange: (v: number) => void = () => {};

  onTouched = () => {};

  onValueChange(value: number) {
    this.fc.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.fc.disable();
    } else {
      this.fc.enable();
    }

    this.options = { ...this.options, disabled: this.disabled };
    this.cdr.detectChanges();
  }

  writeValue(value: number): void {
    this.fc.setValue(value);
  }
}
